





























import { Vue, Component } from 'vue-property-decorator';
import { Swipe, SwipeItem, Icon, ImagePreview } from 'vant';
import { isWeiXin } from '@/common/ts/common';
import { getDetail } from './api/index';
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Icon);
Vue.use(ImagePreview);
@Component
export default class Detail extends Vue {
  images = [];
  detailData: any = {};
  get id() {
    return this.$route.query.id;
  }
  created() {
    this.fetchDetail();
  }
  async fetchDetail() {
    const res: any = await getDetail(this.id);
    this.images = res.data.p_imgs;
    this.detailData = res.data;
  }

  handlePicShow(index: number) {
    ImagePreview({
      images: this.images,
      startPosition: index,
    });
  }
  buyBtn() {
    window.location.href = this.detailData.p_url;
  }
}
